const headers = [
  {
    text: 'Nombre Completo',
    value: 'name',
    sortable: false
  },
  {
    text: 'Cargo',
    value: 'attendeePosition',
    sortable: false
  },
  {
    text: 'Empresa Visitante',
    value: 'companyName',
    sortable: false
  },
  {
    text: 'Empresa Expositor',
    value: 'expositorCompany',
    sortable: false
  },
  {
    text: '',
    value: 'actions',
    sortable: false,
    width: '20%'
  }
]
export default headers
